// src/components/JarvislyModule/PageHeader/ParametersButton.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import { Button, Tooltip } from 'antd';
import translateX from 'utils/translateX';
import { useModuleStore } from 'stores/module';
import { SettingOutlined } from '@ant-design/icons';
import { useModuleContext } from 'components/core/ModuleProvider';
import useZustand from 'hooks/useZustand';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const ParametersButton = ({
  actions = [],
  actionContext,
  label,
  tooltip,
  icon,
  type,
  disabled,
  onClick,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedModule = useZustand('module', 'config');
  const storedCurrentPage = useZustand('module', 'currentPage');
  const { setShowParametersModal } = useModuleContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const showParametersButton =
    storedCurrentPage?.header?.buttons?.parameters ??
    storedCurrentPage?.header?.buttons?.parameters;
  const ParametersComponent = storedModule?.parametersModalComponent;
  const computedDisabled = disabled ?? !ParametersComponent;

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const defaultOpenParams = () => setShowParametersModal?.();

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick({
        navigate: actionContext?.navigate,
        listSettings: useModuleStore.getState().listSettings,
        page: useModuleStore.getState().currentPage,
        actionContext,
      });
      return;
    }
    defaultOpenParams();
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const buttonIcon = icon || <SettingOutlined />;
  const buttonType = type;
  const defaultTitleKey = ParametersComponent
    ? 'module_parameters'
    : 'no_parameters_component_in_config';
  const title = translateX(tooltip || label || defaultTitleKey);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!showParametersButton) return null;

  return (
    <Tooltip title={title} placement="top">
      <Button
        type={buttonType}
        style={computedDisabled ? { backgroundColor: '#ffffff' } : undefined}
        disabled={computedDisabled}
        icon={buttonIcon}
        onClick={handleClick}
      >
        {isLabelProvided(label) ? translateX(label) : null}
      </Button>
    </Tooltip>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ParametersButton;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function isLabelProvided(label) {
  return !!label && typeof label === 'string';
}
